import React, { useEffect, useState } from "react";
import { _t } from "core/language";
import { type TIngredient } from 'modules/Ingredients/store/types';
import { useFetchCountCart, useGetListCart, useUpdateCart } from "modules/Carts/hooks";
import { UpdateCart } from "modules/Carts/store/types";
import { ActionTypeEnumCart } from "core/config/constant";
import CDialog from "../CDialog";
import { useSelector } from "react-redux";
import { Button } from "../form-controls";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";

interface GroupActionProps {
  listCart: TIngredient[];
}

const AddCart: React.FC<GroupActionProps> = ({
  listCart,
}) => {
  const navigate = useCustomNavigate();
  const [stateDialogExistCart, setStateDialogExistCart] = useState(false);
  const [stateDialogAddCart, setStateDialogAddCart] = useState(false);
  const [stateDialogAddCartSuccess, setStateDialogAddCartSuccess] = useState(false);

  const [lisCartAdd, setListCardAdd] = useState<UpdateCart>(); 
  const { updateCart } = useUpdateCart()
  const { dataList, loadingUpdate } = useSelector((state: any) => state.Carts || {});
  const [nameCartExist, setNameCartExist] = useState<any>(''); 

  const [listIngredient, setListIngredient] = useState<TIngredient[]>([]); 

  const [paramCart] = useState<any>({
    order_by: "id",
    order_dir: "desc",
    page: 1,
    page_size: 1000,
  });
  const {reLoadList} = useGetListCart(paramCart);
  const getCountCartAll = useFetchCountCart();

  useEffect(() => {
    if(!loadingUpdate && lisCartAdd?.ids && lisCartAdd?.ids.length > 0){
      setStateDialogAddCartSuccess(true)
      // navigate(RouterName.CARTS)  
      if(reLoadList){
        reLoadList(paramCart)
      }
      if(getCountCartAll){
        getCountCartAll()
      }
    }
  },[loadingUpdate])

  useEffect(() => {
    if(listCart.length > 0){
      setListIngredient(listCart)
    }
  }, [listCart])

  const handleClick = (dataIngredient: any) => {
    const data = listIngredient || dataIngredient;
    const existCart = dataList.filter((item1:any) => data.some((item2:any) => item2.id === item1.id));
    const carts = data.filter((item2:any) => !dataList.some((item1:any) => item1.id === item2.id));
    const dataRequest = {
      ids: data as [],
      action: ActionTypeEnumCart.ADD
    }
    console.log(carts,'carts', dataRequest)
    if(data.length > 0){
      setListCardAdd(dataRequest as UpdateCart);
    }
    
    if (existCart.length > 0) {
      // setStateDialogExistCart(true)
      const names = existCart.map((item:any) => item.name).join(", ");
      setNameCartExist(names)
    } else {
      // setStateDialogAddCart(true)
    }
    setTimeout(() => {
      handleAddCart(dataRequest)
    }, 100)
  }

  const handleAddCart = (dataCartAdd?:any) => {
    const dataCartAdded = dataCartAdd || lisCartAdd;
    const dataCart = {
      ids: dataCartAdded?.ids.map((item:any) => item.id) || '',
      action: dataCartAdded?.action || ''
    } as UpdateCart

    if(dataCartAdded?.ids && dataCartAdded?.ids.length > 0){
      updateCart(dataCart)
      setStateDialogAddCart(false)
      setStateDialogExistCart(false)
      // return
    }
    // navigate(RouterName.CARTS)
    // setStateDialogAddCart(false) // cr NO.22
  }

  const handleToCart = () => {
    navigate(RouterName.CARTS)
  }
  // console.log(listIngredient,'listCart', listCart)
  return <>
    <Button
      disabled={(listCart.length) > 0  && !loadingUpdate ? false : true}
      label={_t('aiChef.ingredient.add_to_cart')}
      onClickBtn={() => handleClick(listIngredient)}
      classBtn="w-full"
    />
    <CDialog
      open={stateDialogExistCart}
      closeModal={() => { setStateDialogExistCart(false) }}
      classNamechildren={'pb-[20px]'}
      handleSubmit={handleAddCart}
      submitText={_t('recipe.msg.confirm')}
      closeText={_t('recipe.msg.cancel')}
    >
      <p className="text-sm font-medium">{_t('recipe.recipe_want_add_to_cart')}</p>
      <p className="text-[11px] font-medium">(<span className="text-[#ff6741]">{`${nameCartExist}`}</span> {_t('recipe.recipe_exist_in_cart_should_exclued')})</p>
    </CDialog>
    <CDialog
      open={stateDialogAddCart}
      closeModal={() => { setStateDialogAddCart(false) }}
      classNamechildren={'pb-[20px]'}
      handleSubmit={handleAddCart}
      submitText={_t('recipe.msg.confirm')}
      closeText={_t('recipe.msg.cancel')}
    >
      <p className="text-sm font-medium">{_t('recipe.recipe_want_add_to_cart')}</p>
    </CDialog>
    <CDialog
      open={stateDialogAddCartSuccess}
      closeModal={() => { setStateDialogAddCartSuccess(false) }}
      classNamechildren={'pb-[20px]'}
      handleSubmit={handleToCart}
      submitText={_t('recipe.recipe_move')}
      closeText={_t('recipe.recipe_close')}
    >
      <p className="text-sm font-medium">{_t('recipe.recipe_add_cart_success')}</p>
      <p className={`text-[11px] font-medium ${nameCartExist ? '' : ' hidden'}`}>(<span className="text-[#ff6741]">{`${nameCartExist}`}</span> {_t('recipe.recipe_exist_in_cart_should_exclued')})</p>
    </CDialog>
  </>
};

export default AddCart;
